export default {
  user: {},
  token: '',
  acesso: {},
  header: {},
  menu: [],
  errorsHttp: [],
}